import React from "react";

const ReportsSync = () => {
    return (
        <div className="content">
            <div className="col-12">
                <div id="page-header">
                    <h1>2 товари синхронізовано з Dropbox</h1>
                </div>

                <div className="no-print ">
                    <a
                        href="/reports?type=sync&amp;mode=1"
                        className="btn btn-primary mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        Не синхронізовані
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2"
                        className="btn btn-info mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        Синхронізовані
                    </a>
                </div>

                <div className="no-print  margin20">
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=23"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        Geeg
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=37"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        ViFi Darnytsya
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=51"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        ViFi Ready To Sale
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=2"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        ViFi Yurkivska
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=39"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        Vobbi Chernihivska
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=29"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        Vobbi Frankivsk
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=40"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        Vobbi Leningradska
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=46"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        YNL Beresteika
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=54"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        YNL Obolon
                    </a>
                    <a
                        href="/reports?type=sync&amp;mode=2&amp;store_id=25"
                        className="btn btn-primary no-print mx-1"
                        style={{ marginBottom: "5px" }}
                    >
                        Yountel Online
                    </a>
                </div>

                <form id="list_form" method="post">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th data-field="id">ID</th>
                                <th data-field="user_name" className="no-mobile">
                                    Магазин
                                </th>
                                <th className="no-mobile">Додано</th>
                                <th data-field="user_name">Назва</th>
                                <th data-field="user_imei" className="no-mobile">
                                    IMEI
                                </th>{" "}
                                <th data-field="user_address" className="no-mobile">
                                    Ціна
                                </th>
                                <th data-field="user_date" className="text-nowrap no-mobile">
                                    Дата синхронізаці
                                </th>{" "}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>#111022</td>
                                <td className="text-nowrap no-mobile">ViFi Ready To Sale</td>
                                <td className="no-mobile">09.05.2022</td>
                                <td>
                                    <div>
                                        Apple iPhone 8 64GB Space Gray AT&amp;T (67074) The device you want to unlock is
                                        active on another AT&amp;T account{" "}
                                        <div className="">
                                            /inStyle/inStyle_Vatutina/Phones/Apple iPhone 8 64GB Space Gray Neverlock
                                            Ціна-5900 (<b>67074</b>)
                                        </div>
                                    </div>
                                    <div className="note note-note on-mobile">
                                        <i className="fas fa-search"></i> 2022-06-13 12:00:06
                                    </div>{" "}
                                </td>
                                <td className="no-mobile">356392104367074</td>{" "}
                                <td className="no-mobile">1.00&nbsp;грн</td>
                                <td className="text-nowrap no-mobile">2022-06-13 12:00:06</td>{" "}
                            </tr>
                            <tr>
                                <td>#95328</td>
                                <td className="text-nowrap no-mobile">ViFi Yurkivska</td>
                                <td className="no-mobile">29.09.2021</td>
                                <td>
                                    <div>
                                        Apple iPhone 11 Pro 64GB Gold Neverlock (38062){" "}
                                        <div className="">
                                            /inStyle/inStyle_Vatutina/Phones/Apple iPhone 11 Pro 64GB Gold Neverlock
                                            Ціна-18500 (<b>38062</b>)
                                        </div>
                                    </div>
                                    <div className="note note-note on-mobile">
                                        <i className="fas fa-search"></i> 2023-01-13 12:20:03
                                    </div>{" "}
                                </td>
                                <td className="no-mobile">353830108938062</td>{" "}
                                <td className="no-mobile">18653.00&nbsp;грн</td>
                                <td className="text-nowrap no-mobile">2023-01-13 12:20:03</td>{" "}
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>
    );
};

export default ReportsSync;
